import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningAmber from '@mui/icons-material/WarningAmber';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Toggle } from '@/ui';
import { useUpdateStatus } from '../../../../utils/queries';
import StatusToggleFrame from '../../../../components/StatusToggleFrame/StatusToggleFrame';

/** `framed` wraps the switch in the tinted Active/Inactive pill the detail headers use. */
const ToggleActiveModal = ({ isActive: initialIsActive, modalType, content, endpoint, framed = false }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isActiveStatus, setActiveStatus] = useState(initialIsActive);
  const updateStatusMutation = useUpdateStatus(endpoint);

  const toggleActive = () => setActiveStatus((prevState) => !prevState);

  const handleSave = async () => {
    try {
      const saveData = {
        id: content.id,
        isActive: isActiveStatus,
        zuulUser: JSON.parse(localStorage.getItem('userData')),
      };

      await updateStatusMutation.mutate(saveData);
      setModalOpen(false);
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handleCancel = () => {
    setModalOpen(false);
    setActiveStatus(initialIsActive);
  };

  const toggle = (
    <Toggle
      // On the input, not the root: that is the element carrying the checked state, and it is
      // what the widget this replaced exposed under this id.
      slotProps={{ input: { 'data-testid': 'toggle-switch' } }}
      onChange={() => {
        toggleActive();
        setModalOpen(true);
      }}
      checked={isActiveStatus}
      offColor='error'
      label={isActiveStatus ? 'Active' : 'Inactive'}
    />
  );

  return (
    <div>
      {/* The frame follows the local state, so it previews the pending colour while the confirm
          dialog is open and snaps back with the switch on Cancel. */}
      {framed ? <StatusToggleFrame isActive={isActiveStatus}>{toggle}</StatusToggleFrame> : toggle}
      <Modal isOpen={isModalOpen} toggle={() => setModalOpen(false)} tone='danger'>
        <ModalHeader toggle={() => setModalOpen(false)}>Active Status</ModalHeader>
        <ModalBody>
          <Stack direction='row' spacing={2} sx={{ alignItems: 'flex-start' }}>
            <WarningAmber sx={{ fontSize: '3rem', color: 'error.main', flex: '0 0 auto' }} />
            <div>
              <Typography variant='h6'>{content?.name}</Typography>
              <Typography>
                Are you sure you want to {!isActiveStatus ? 'deactivate ' : 'activate '} this {modalType}?
              </Typography>
            </div>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button color='danger' onClick={handleSave}>
            {!isActiveStatus ? 'Deactivate ' : 'Activate '}
          </Button>
          <Button color='secondary' onClick={handleCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ToggleActiveModal;
